/**
 * Справочники фильтров раздела «Клиенты»: статусы со счётчиками и города.
 * Живой режим — /admin/clients/status-counts и /admin/refs/cities;
 * мок — те же данные из MOCK_CLIENTS (getStatusCounts/getCities сами решают).
 */

import {useQuery} from '@tanstack/react-query';

import {
  getCities,
  getSpecializations,
  getStatusCounts,
  STATUS_META,
  type StatusOption,
} from '@services/clients';
import {keys} from '@queries/keys';

/** Опции фильтра «Статус» с живыми счётчиками; до загрузки — без чисел */
export const useStatusOptions = (): StatusOption[] => {
  const {data} = useQuery({
    queryKey: keys.clients.statusCounts(),
    queryFn: getStatusCounts,
    staleTime: 60_000,
  });
  return STATUS_META.map((m) => ({...m, count: data?.[m.value] ?? 0}));
};

/** Имена городов для фильтра «Город» (в id их переводит getClients) */
export const useCityOptions = (): string[] => {
  const {data = []} = useQuery({
    queryKey: keys.clients.cities(),
    queryFn: getCities,
    staleTime: 300_000,
  });
  return data.map((c) => c.name);
};

/** Имена специализаций для селектов врачей (в id переводят мутации) */
export const useSpecializationOptions = (): string[] => {
  const {data = []} = useQuery({
    queryKey: keys.clients.specializations(),
    queryFn: getSpecializations,
    staleTime: 300_000,
  });
  return data.map((s) => s.name);
};
